<div class="st-drawer-wrapper opportunities-details-drawer flex flex-column">
  <a href=""></a>

  @if (viewMode === 'budget' ? budget : opportunity) {
    <!--  Header  -->
    <div class="st-drawer-header show-border flex-center-between">
      <div class="flex-center gap-150">
        @if (viewMode === 'budget') {
          <!-- Navegación entre presupuestos -->
          @if (hasMultipleBudgets) {
      <button (click)="changeBudget(false, true)" nz-button nzType="text" nzShape="circle" nzSize="small"
              class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_up'">
              </app-st-icon>
            </button>
      <button (click)="changeBudget(true, false)" nz-button nzType="text" nzShape="circle" nzSize="small"
              class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_down'">
              </app-st-icon>
            </button>
          }
      <span class="text-label-14" style="color: #666666;">Sub Tareas /</span>
      <span class="text-label-14 text-semibold text-nowrap cursor-pointer" (click)="closeBudgetView()"
            style="color: #666666; text-decoration: none;">
        sub tarea 1
          </span>
          <span class="text-label-14" style="color: #666666;">/</span>
      <div class="flex-center gap-050 cursor-pointer" nz-dropdown nzTrigger="click"
            [nzDropdownMenu]="hasMultipleBudgets ? budgetDropdownTmpl : null">
        <span class="text-label-14 text-semibold text-nowrap" style="color: #171717; text-decoration: none;">{{
          budgetName }}</span>
        <app-st-icon *ngIf="hasMultipleBudgets" [bold]="true" [name]="'keyboard_arrow_down'">
            </app-st-icon>
          </div>

          <nz-dropdown-menu #budgetDropdownTmpl="nzDropdownMenu">
            <ul nz-menu class="opportunity-dropdown">
              @for (budgetItem of budgetList; track budgetItem.id) {
          <li (click)="changeBudget(false, false, budgetItem.id)" [class.selected]="budgetItem.id === budget?.id"
            nz-menu-item style="min-width: fit-content">
                  {{ budgetItem.name || '-' }}
                </li>
              }
            </ul>
          </nz-dropdown-menu>
        } @else {
          <!-- Navegación entre oportunidades/leads -->
          @if (hasMultipleOpportunities) {
      <button (click)="changeOpportunity(false, true, currentOpportunityId)" nz-button nzType="text" nzShape="circle"
        nzSize="small" class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_up'">
              </app-st-icon>
            </button>
      <button (click)="changeOpportunity(true, false, currentOpportunityId)" nz-button nzType="text" nzShape="circle"
        nzSize="small" class="flex-center">
        <app-st-icon [bold]="true" style="font-size: 18px" class="cursor-pointer" [name]="'keyboard_arrow_down'">
              </app-st-icon>
            </button>
          }
          @if (isLead) {
            <span class="text-label-14" style="color: #666666;">Leads /</span>
          } @else {
      <span class="text-label-14" style="color: #666666;">Sub Tareas /</span>
          }
      <div class="flex-center gap-050 cursor-pointer" nz-dropdown nzTrigger="click"
            [nzDropdownMenu]="hasMultipleOpportunities ? opportunityDropdownTmpl : null">
        <span class="text-label-14 text-semibold text-nowrap" style="color: #171717; text-decoration: none;">{{
          serviceOrder?.subtaskName || 'Sin nombre' }}</span>
        <app-st-icon *ngIf="hasMultipleOpportunities" [bold]="true" [name]="'keyboard_arrow_down'">
            </app-st-icon>
          </div>

          <nz-dropdown-menu #opportunityDropdownTmpl="nzDropdownMenu">
            <ul nz-menu class="opportunity-dropdown">
              @for (opp of nzData.opportunityList; track opp.id || opp.originalId) {
          <li (click)="changeOpportunity(false, false, opp.id || opp.originalId)"
            [class.selected]="(opp.id || opp.originalId) === currentOpportunityId" nz-menu-item
                  style="min-width: fit-content">
                  {{ opp.oportunidad || opp.originalOpportunityName || opp.name || '-' }}
                </li>
              }
            </ul>
          </nz-dropdown-menu>
        }
      </div>
    <app-st-icon class="text-header-16" style="cursor: pointer" (click)="close()" name="close"></app-st-icon>
    </div>

    @if (!loading) {
      <!-- Título, botón de editar y acciones -->
      <div class="opportunity-header-section">
        <div class="flex-center gap-200">
          @if (viewMode === 'budget') {
            <h2 class="text-header-24 text-semibold">{{ budgetName }}</h2>
            <ng-container *ngIf="nzData.editPermissions">
        <button *ngIf="!isBudgetEditModeEnabled" (click)="startEditModeBudget()" nz-button nzType="default"
                nzShape="round">
          <app-st-icon class="text-header-16 cursor-pointer prefix" style="margin-right: 8px" name="edit"
            [bold]="true"></app-st-icon>
                Editar presupuesto
              </button>
              <ng-container *ngIf="isBudgetEditModeEnabled">
          <button nz-button nzType="default" nzShape="round" style="margin-right: 8px"
                  (click)="confirmCancelEditModeBudget()">
            <app-st-icon class="text-header-16 cursor-pointer prefix" style="margin-right: 8px" name="close"
              [bold]="true"></app-st-icon>
                  Cancelar
                </button>
          <button nz-button nzType="primary" nzShape="round" [nzLoading]="savingBudget" (click)="saveEditModeBudget()">
            <app-st-icon class="text-header-16 cursor-pointer prefix" style="margin-right: 8px; color: #ffffff;"
              name="done" [bold]="true"></app-st-icon>
                  Guardar
                </button>
              </ng-container>
            </ng-container>
          } @else {
      <h2 class="text-header-24 text-semibold">{{ serviceOrder?.subtaskName || 'Sin nombre' }}</h2>
            <ng-container *ngIf="nzData.editPermissions">
        <button *ngIf="!isEditModeEnabled" (click)="startEditMode()" nz-button nzType="default" nzShape="round">
          <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" name="edit"
            [bold]="true"></app-st-icon>
          {{ isLead ? 'Editar lead' : 'Editar subtarea' }}
              </button>
              <ng-container *ngIf="isEditModeEnabled">
          <button nz-button nzType="default" nzShape="round" style="margin-right: 8px"
            [disabled]="savingServiceOrder" (click)="savingServiceOrder ? null : confirmCancelEditMode()">
            <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px" name="close"
              [bold]="true"></app-st-icon>
                  Cancelar
                </button>
          <button nz-button nzType="primary" nzShape="round" [nzLoading]="savingServiceOrder"
            (click)="savingServiceOrder ? null : saveEditMode()">
            <app-st-icon class="text-header-16 cursor-pointer " style="margin-right: 8px; color: #ffffff;" name="done"
              [bold]="true"></app-st-icon>
                  Guardar
                </button>
              </ng-container>
            </ng-container>
          }
        </div>

        <div class="flex-center gap-100">
          @if (viewMode === 'budget') {
            <!-- Botones de presupuesto -->
      <button nz-button nzType="default" nzShape="round" (click)="closeBudgetView()">
              Volver
            </button>
      <button *ngIf="hasBudgetQuotationLines" nz-button nzType="default" nzShape="round" (click)="openBudgetPreview()">
              Vista previa
            </button>
      <button *ngIf="hasBudgetQuotationLines && budget?.isActive" nz-button nzType="primary" nzShape="round"
        [disabled]="!budget?.id || generatingVersion" [nzLoading]="generatingVersion" (click)="generateBudgetVersion()">
              {{ generatingVersion ? 'Generando…' : 'Generar presupuesto' }}
            </button>
            @if (budget?.dateCancelled) {
              <!-- Si está cancelado, mostrar botón de recuperar -->
      <button nz-button nzType="default" nzShape="round" (click)="recoverBudget()" [nzLoading]="recoveringBudget">
                Recuperar Presupuesto
              </button>
            } @else {
              <!-- Si no está cancelado, mostrar botones normales -->
      <button nz-button nzType="default" nzShape="round" (click)="cancelBudget()" [nzLoading]="cancelingBudget">
                Cancelar Presupuesto
              </button>
              @if (!budget?.dateConfirm) {
                <!-- Solo mostrar si no está aprobado -->
      <button nz-button nzType="default" nzShape="round" (click)="requestApproval()" [nzLoading]="requestingApproval">
                  Solicitar Aprobación
                </button>
              }
              @if (!budget?.dateConfirm) {
                <!-- Solo mostrar si no está confirmado -->
      <button nz-button nzType="primary" nzShape="round" (click)="confirmBudget()" [nzLoading]="confirmingBudget">
                  Confirmar
                </button>
      <button nz-button nzType="primary" nzShape="round" (click)="adoptBudget()" [nzLoading]="adoptingBudget">
                  Adoptar Presupuesto
                </button>
              }
            }
          } @else {
            <!-- Avatar group -->
            @if (!isLead) {
              <nz-avatar-group>
                @for (user of opportunityUsers.slice(0, 5); track user.id) {
                  <nz-avatar
                    [nzSize]="32"
                    [nzSrc]="user.avatar ? getSafeImageUrl(user.avatar) : undefined"
                    [nzText]="!user.avatar ? getUserInitialsFromUser(user) : undefined"
                    [style.backgroundColor]="!user.avatar ? '#ffffff' : undefined"
                    [style.color]="!user.avatar ? '#000000' : undefined"
                    [style.border]="!user.avatar ? '1px solid #d9d9d9' : undefined"
                    [style.fontWeight]="!user.avatar ? '600' : undefined"
                    nz-tooltip
                    [nzTooltipTitle]="user.name + ' ' + user.surName">
                  </nz-avatar>
                }
              </nz-avatar-group>

              <nz-divider nzType="vertical" style="height: 32px; margin: 0 8px;"></nz-divider>
            }

            <!-- Botones de acción -->
      @if (!isLead && !isLost && !isWon) {
      <button nz-button nzType="default" [nzDanger]="true" nzShape="round" (click)="deleteCurrentServiceOrder()">
        <app-st-icon class="text-header-16 cursor-pointer" style="color: #ff4d4f !important; margin-right: 8px" [name]="'delete'" [bold]="true">
        </app-st-icon>
        Eliminar
      </button>

      <button nz-button nzType="primary" nzShape="round" (click)="createSubtask()">
        <app-st-icon class="text-header-16 cursor-pointer" style="margin-right: 8px; color: white;" [name]="'add'" [bold]="true">
                </app-st-icon>
        Añadir subtarea
      </button>
       }

            @if (!isLead && !isLost && !isWon) {
              <nz-divider nzType="vertical" style="height: 32px; margin: 0 8px;"></nz-divider>
            }

            @if (isLead && !isLost) {
      <button nz-button nzType="primary" nzShape="round" (click)="convertToOpportunity()">
                Convertir en oportunidad
              </button>
            } @else if (!isLead && !isLost && canCreateQuote) {
      <app-split-btn class="budget-split-btn" [buttonType]="'default'" [primaryIcon]="'add'"
        [secondaryIcon]="'arrow_drop_down'" [text]="'Nuevo Presupuesto'" [dropdownItems]="[
                  {label: 'Nueva oportunidad', action: 'newOpportunity'},
                    {label: 'Nuevo proyecto', action: 'newProject'},
                ]" (primaryActionEvent)="openBudgetDrawer()"
                (dropdownActionEvent)="onSplitButtonDropdownAction($event)">
              </app-split-btn>
            }
          }
        </div>

        <!-- Botón para expandir/colapsar panel de actividades en móvil -->
        <button
          *ngIf="screenService.isMobile$ | async"
          nz-button
          nzType="default"
          nzShape="circle"
          nzSize="small"
          class="activities-toggle-btn"
          [title]="showActivitiesPanel ? 'Colapsar actividades' : 'Expandir actividades'"
          (click)="toggleActivitiesPanel()">
          <app-st-icon
            [name]="showActivitiesPanel ? 'expand_less' : 'expand_more'"
            [bold]="true">
          </app-st-icon>
        </button>
      </div>

      <div class="st-drawer-content opportunity-details-content">
        <!-- Contenedor principal con tabs y sidebar -->
        <div class="main-content-wrapper" [class.expanded-panel]="!showActivitiesPanel">
          <!-- Contenido principal con tabs -->
          <div class="main-content">
            <!-- Stepper -->
            <div class="stepper">
              @if (viewMode === 'budget') {
                <!-- Stepper de presupuesto -->
                @for (stage of budgetStages; track stage.value; let isLast = $last) {
          <div class="stepper-item"
            [style.color]="isCurrentBudgetStage(stage.value) ? stage.color : null"
            [style.cursor]="nzData.editPermissions ? 'pointer' : 'default'"
            (click)="nzData.editPermissions && changeBudgetStage(stage)">
                    <app-st-icon [bold]="true" [name]="stage.icon"></app-st-icon>
                    <span>{{ stage.name }}</span>
                  </div>
                  @if (!isLast) {
                    <app-st-icon name="keyboard_arrow_right"></app-st-icon>
                  }
                }
              } @else {
                <!-- Stepper de oportunidad/lead: iconos y colores configurados al crear/editar el proyecto -->
          @for (flow of flows; track flow.id) {
            @for (event of getSortedFlowEvents(flow); track event.id; let isLast = $last; let index = $index) {
                <div class="stepper-item"
          [class.active]="isCurrentEvent(event)"
          [style.color]="isCurrentEvent(event) && event.color ? event.color : null"
          [style.cursor]="isEditModeEnabled && canChangeToState(event) ? 'pointer' : 'default'"
          (click)="handleEventClick(event)">
          <app-st-icon [bold]="true" [name]="event.icon || 'timeline'"></app-st-icon>
          <span>{{ event.name }}</span>
                </div>
                  @if (!isLast) {
                    <app-st-icon name="keyboard_arrow_right"></app-st-icon>
                  }
            }
                }
              }
            </div>
            @if (viewMode === 'budget') {
              <!-- Vista de presupuesto -->
        <app-budget-content [budget]="budget" [opportunity]="opportunity" [budgetList]="budgetList"
          [currentBudgetIndex]="currentBudgetIndex" [activeTabIndex]="activeTabIndex"
          [editPermissions]="nzData.editPermissions" [isEditModeEnabled]="isBudgetEditModeEnabled"
          [editModeAction]="budgetEditModeAction" (fieldUpdate)="onBudgetFieldUpdate($event)"
                (budgetChange)="changeBudget($event.isNext, $event.isPrev, $event.budgetId)"
                (quotationLinesAvailabilityChange)="hasBudgetQuotationLines = $event"
                [pdfVersionsRefreshKey]="pdfVersionsRefreshKey">
              </app-budget-content>
            } @else if (viewMode === 'lead') {
              <!-- Vista de lead -->
        <app-lead-content [lead]="opportunity" [editPermissions]="nzData.editPermissions"
          [isEditModeEnabled]="isEditModeEnabled" [editModeAction]="editModeAction" [activeTabIndex]="activeTabIndex"
          [documents]="documents" (fieldUpdate)="onFieldUpdate($event)">
              </app-lead-content>
            } @else if (serviceOrder) {
        <!-- Vista de service order -->
        <app-order-details-content
          [serviceOrder]="serviceOrder"
                [editPermissions]="nzData.editPermissions"
                [documents]="documents"
                [budgets]="budgetList"
          [activeTabIndex]="activeTabIndex"
          [isEditModeEnabled]="isEditModeEnabled"
                (fieldUpdate)="onFieldUpdate($event)"
          (budgetClick)="onBudgetClick($event)">
        </app-order-details-content>
            } @else {
              <!-- Fallback si no hay serviceOrder -->
              <div class="no-data-message">
                <p>No hay datos disponibles</p>
              </div>
            }
          </div>

          <!-- Panel de actividades (debajo en móvil) -->
          <div class="right-container" [class.mobile-collapsed]="!showActivitiesPanel">
        <app-activities-panel [loadingActivities]="loadingActivities"
          [activitiesGroupedByDate]="activitiesGroupedByDate" [opportunity]="opportunity"
          [chatName]="getOpportunityName()" [showChat]="true" [users]="globalValuesService.users$.value"
              [loggedUser]="authService.loggedUser$.value"
              [getActivityIconWrapperClassFn]="getActivityIconWrapperClass.bind(this)"
          [getActivityIconFn]="getActivityIcon.bind(this)" [getActivityIconColorFn]="getActivityIconColor.bind(this)"
          [getActivityTimeFn]="getActivityTime.bind(this)" [getActivityDueDateFn]="getActivityDueDate.bind(this)"
          [getUserInitialsFn]="getUserInitials.bind(this)" [getUserFullNameFn]="getUserFullName.bind(this)"
              [getActivityStatusClassFn]="getActivityStatusClass.bind(this)"
              [getActivityStatusLabelFn]="getActivityStatusLabel.bind(this)"
          (openCreateActivity)="openCreateActivityDrawer()" (openRegisterNote)="openRegisterNoteDrawer()"
          (markDone)="markActivityAsCompleted($event)" (editActivity)="openEditActivityDrawer($event)"
          (cancelActivity)="cancelActivityAction($event)"></app-activities-panel>
          </div>
        </div>
      </div>
    } @else {
      <nz-skeleton style="padding: 32px" [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
    }
  }
</div>


<!-- Template: Notificación Toast -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo" [notRef]="notRef" [content]="toastConfig.content"
    [msg]="toastConfig.msg"></app-toast>
</ng-template>

<!-- Template: Modal Marcar como Perdido -->
<ng-template #markAsLostModalTmpl>
  <div class="mark-as-lost-modal">
    <div class="flex-center-between">
      <h2 class="text-header-18">{{ 'Marcar perdido' }}</h2>
      <app-st-icon (click)="cancelMarkAsLost()" class="cursor-pointer" name="close" [bold]="true"></app-st-icon>
    </div>

    <form [formGroup]="lostForm">
      <!-- Razón de pérdida -->
      <div>
        <span class="text-label-10">Razón de pérdida</span>
        <nz-select formControlName="reason" nzSize="large" nzPlaceHolder="Seleccione" nzShowSearch
          style="width: 100%; margin-top: 8px;">
          <nz-option *ngFor="let reason of lostReasons" [nzValue]="reason.name" [nzLabel]="reason.name">
          </nz-option>
        </nz-select>
      </div>

      <!-- Nota de cierre -->
      <div style="margin-top: 16px;">
        <span class="text-label-10">Nota de cierre</span>
        <textarea formControlName="lostNote" nzSize="large" nz-input placeholder="¿Qué salió mal?" rows="4"
          class="info-text" style="margin-top: 8px;">
        </textarea>
      </div>

      <!-- Botones -->
      <div class="flex-center-between footer">
        <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="cancelMarkAsLost()">
          Cancelar
        </button>
        <button nz-button nzType="primary" nzShape="round" nzSize="large" [nzLoading]="markingAsLost"
          [disabled]="lostForm.invalid" (click)="confirmMarkAsLost()"
          style="background-color: #000000; border-color: #000000;">
          <app-st-icon [name]="'cancel'" [bold]="true" class="prefix" style="color: white;">
          </app-st-icon>
          <span style="color: white;">Marcar como perdido</span>
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Template: Modal Completar Actividad -->
<ng-template #completionModalTmpl>
  <div style="padding: 40px 32px;">
    <div style="margin-bottom: 32px;">
      <label style="font-weight: 500; color: #666; display: block; margin-bottom: 12px; font-size: 14px;">Asignada a:</label>
      <div style="display: flex; align-items: center; gap: 12px; padding: 16px; background-color: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef;">
        <nz-avatar
          [nzSize]="40"
          [nzSrc]="completionModalActivity?.user?.partner?.avatar ? getSafeImageUrl(completionModalActivity?.user?.partner?.avatar) : undefined"
          [nzText]="!completionModalActivity?.user?.partner?.avatar ? getUserInitials(completionModalActivity!) : undefined"
          style="background-color: #ffffff; color: #000000; font-weight: 600; border: 1px solid #d9d9d9;">
        </nz-avatar>
        <div>
          <div style="font-weight: 600; color: #333; font-size: 16px;">
            {{ completionModalActivity?.user?.partner?.name || 'Sin asignar' }}
          </div>
          <div style="font-size: 14px; color: #666;">
            {{ completionModalActivity?.user?.partner?.surName || '' }}
          </div>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 32px;">
      <label for="completionNote" style="font-weight: 500; color: #666; display: block; margin-bottom: 12px; font-size: 14px;">Notas de completación:</label>
      <textarea
        id="completionNote"
        nz-input
        [value]="completionNote"
        (input)="onCompletionNoteChange($event)"
        placeholder="Agregue notas sobre la completación de esta actividad..."
        style="width: 100%; min-height: 140px; resize: vertical; border: 1px solid #d9d9d9; border-radius: 6px; padding: 12px; font-size: 14px; line-height: 1.5;"
        rows="6"
      ></textarea>
    </div>

    <!-- Botones -->
    <div class="flex-center-between" style="margin-top: 32px; padding-top: 24px; border-top: 1px solid #e9ecef;">
      <button
        nz-button
        nzType="primary"
        nzShape="round"
        nzSize="large"
        (click)="closeCompletionModal()"
        style="background-color: #000000; border-color: #000000;">
        <app-st-icon
          [name]="'check_circle'"
          [bold]="true"
          class="prefix"
          style="color: white; margin-right: 8px;">
        </app-st-icon>
        Hecho y siguiente actividad
      </button>
      <div style="display: flex; gap: 12px;">
        <button
          nz-button
          nzType="text"
          nzShape="round"
          nzSize="large"
          (click)="cancelCompletionModal()">
          Cancelar
        </button>
        <button
          nz-button
          nzType="primary"
          nzShape="round"
          nzSize="large"
          (click)="confirmCompleteActivity()"
          style="background-color: #000000; border-color: #000000;">
          <app-st-icon
            [name]="'done'"
            [bold]="true"
            class="prefix"
            style="color: white; margin-right: 8px;">
          </app-st-icon>
          Hecho
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Confirmation Modal for State Change -->
<app-confirmation-modal
  #confirmationModal
  [config]="confirmationModalConfig"
  (confirmed)="onStateChangeConfirmed($event)"
></app-confirmation-modal>
